import { render, staticRenderFns } from "./MyPushuDetail.vue?vue&type=template&id=623b2d3e&scoped=true&"
import script from "./MyPushuDetail.vue?vue&type=script&lang=js&"
export * from "./MyPushuDetail.vue?vue&type=script&lang=js&"
import style0 from "./MyPushuDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MyPushuDetail.vue?vue&type=style&index=1&id=623b2d3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623b2d3e",
  null
  
)

export default component.exports